import { uniq } from 'lodash';
import { TransportMode } from '../../../../../common/constants/transport-mode';
import { LoadStatus } from '../../../shipment-load/models/load.model';
import { Dates, Deviation } from '../../../../models';
import { MonitoringStatus } from '../../../../constants';
import { Origin, Region } from '../constants/transport-list.constant';

export class LoadPrimary {
  loadNumber: string;
  carrierId: string;
  carrierName: string;
  scac: string;
  pickupExtId: string;
  pickupName: string;
  pickupAddress: string;
  deliveryExtId: string;
  deliveryName: string;
  deliveryAddress: string;
  deviation: Deviation;
  transportMode: TransportMode;
  transportOrders: TransportOrderSecondary[];
  status: MonitoringStatus;
  webLoadStatusView: LoadStatus;
  dates: Dates;
  isCancelled: boolean;
  origin: Origin;
}

export class TransportOrderSecondary {
  toNumber: string;
  dates: Dates;
  departureDelay: number;
  arrivalDelay: number;
  status: MonitoringStatus;
  deviation: Deviation;
  shippedFromAddress: string;
  shippedFromExtId: string;
  shippedFromName: string;
  shippedToAddress: string;
  shippedToExtId: string;
  shippedToName: string;
}

export class TransportOrderPrimary {
  toNumber: string;
  deviation: Deviation;
  status: MonitoringStatus;
  consignorExtId: string;
  consignorName: string;
  consignorAddress: string;
  recipientExtId: string;
  recipientName: string;
  recipientAddress: string;
  dates: Dates;
  loads: LoadSecondary[];

  get transportModes(): TransportMode[] {
    return uniq(this.loads.map((item: LoadSecondary) => item.transportMode));
  }

  constructor(params?: Partial<TransportOrderPrimary>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class LoadSecondary {
  loadNumber: string;
  region: Region;
  carrierId: string;
  carrierName: string;
  scac: string;
  pickupExtId: string;
  pickupName: string;
  pickupAddress: string;
  deliveryExtId: string;
  deliveryName: string;
  deliveryAddress: string;
  deviation: Deviation;
  transportMode: TransportMode;
  webLoadStatusView: LoadStatus;
  speedUpInformation: string;
  dates: Dates;
  isCancelled: boolean;
}
